import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import currentState from './modules/currentState'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    currentState
  },
  // 内存数据状态，UI可通过this.$store.state.* 获得数据
  state: {
    isLogin: false
  },
  // 唯一拥有更改内存数据的接口，不可进行异步操作
  mutations: {},
  actions: {}
})
